export default "__VITE_ASSET__RHhijpXF__"